import React from "react";
import { motion } from "framer-motion";
import SectionTitle from "../components/SectionTitle";

export default function ContactSection() {
  return (
    <section id="contact" className="bg-brand-dark">
      <div className="mx-auto max-w-6xl px-4 py-16 sm:py-20">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <SectionTitle
            eyebrow="Contact"
            title="Let’s build something great"
            desc="Drop a message for partnerships, publishing, or collaboration."
          />
        </motion.div>

        <motion.div
          className="mx-auto mt-10 max-w-2xl rounded-3xl border border-white/10 bg-white/5 p-6 sm:p-8"
          initial={{ opacity: 0, y: 18 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <form
            onSubmit={(e) => {
              e.preventDefault();
              alert("Form submitted (hook this to your backend later).");
            }}
            className="grid gap-4"
          >
            <div className="grid gap-4 sm:grid-cols-2">
              <input
                className="rounded-xl border border-white/10 bg-black/40 px-4 py-3 text-sm text-white placeholder:text-white/40 outline-none focus:border-brand-red/60"
                placeholder="Your name"
              />
              <input
                className="rounded-xl border border-white/10 bg-black/40 px-4 py-3 text-sm text-white placeholder:text-white/40 outline-none focus:border-brand-red/60"
                placeholder="Email"
                type="email"
              />
            </div>

            <input
              className="rounded-xl border border-white/10 bg-black/40 px-4 py-3 text-sm text-white placeholder:text-white/40 outline-none focus:border-brand-red/60"
              placeholder="Subject"
            />

            <textarea
              className="min-h-[120px] rounded-xl border border-white/10 bg-black/40 px-4 py-3 text-sm text-white placeholder:text-white/40 outline-none focus:border-brand-red/60"
              placeholder="Tell us what you're building..."
            />

            <button
              type="submit"
              className="mt-2 inline-flex items-center justify-center rounded-xl bg-brand-red px-6 py-3 text-sm font-semibold text-white shadow-soft transition hover:opacity-90"
            >
              Send message
            </button>

            <p className="text-center text-xs text-white/50">
              ProPlay Studios is a Proviloops company.
            </p>
          </form>
        </motion.div>
      </div>
    </section>
  );
}
